<template>
  <b-autocomplete
    v-model="keyword"
    async
    icon="magnify"
    :data="data"
    field="label"
    placeholder="Search an artist (eg: Elvis Presley, The Beatles)"
    :keep-first="true"
    :loading="isFetching"
    @input="getAsyncData"
    @select="select"
  >
    <template slot-scope="props">
      <b>{{ props.option.label }}</b> {{ props.option.birth_year.split('-')[0] }}
    </template>

    <template slot="empty">
      No result
    </template>
  </b-autocomplete>
</template>

<script>

import debounce from "lodash/debounce";
import { toArtist } from "@/services/navigator";
import { searchFormat } from "@/services/helpers"; 

export default {
	data () {
		return {
			keyword: "",
			isFetching: false,
			data: []
		};
	},
	methods: {
		getAsyncData: debounce(function() {
			this.isFetching = true;

			this.data = Object.values(this.$store.state.artists).filter(artist => {
				return searchFormat(artist.name).indexOf(searchFormat(this.keyword)) >= 0;
			}).slice(0,30);

			this.isFetching = false;
		}, 500),
		select (value) {
			toArtist(value.id);
		}
	}
};
</script>
